<nav class="app-topnav">
  <div class="app-topbar-wrapper">
    <div class="app-topbar-logo-wrapper" data-test-id="app-topnav-logo-wrapper">
      @if (logoUrl()) {
      <img
        [attr.src]="logoUrl()"
        attr.alt="logo"
        data-test-id="app-topnav-logo-img"
      />
      } @else {
      <app-aaptiv-logo
        width="100%"
        height="40"
        data-test-id="app-topnav-logo-component"
      ></app-aaptiv-logo>
      }
    </div>
    @if(showTenants()){
    <div class="app-topbar-tenant-wrapper">
      <app-admin-tenant-select
        [list]="tenants()"
        [selectedTenant]="selectedTenant()"
        data-test-id="app-topnav-tenant-select"
        (onSelect)="onSelect($event)"
      ></app-admin-tenant-select>
    </div>
    } @if (user?.name) {
    <div
      class="app-topbar-dropdown-menu-wrapper"
      #dropdownMenu
      data-test-id="app-topnav-dropdown-wrapper"
    >
      <button
        class="app-topbar-dropdown-menu-button"
        type="button"
        (click)="handleToggle()"
        data-test-id="app-topnav-dropdown-button"
      >
        {{ user?.name }}
        <svg
          aria-label="dropdown menu icon"
          class="app-topbar-dropdown-menu-icon"
          viewBox="0 0 13.54 16"
          fill="#fff"
          data-test-id="app-topnav-dropdown-icon"
        >
          <path
            d="M2.42263 6.19526C2.64303 5.93491 3.00037 5.93491 3.22077 6.19526L6.77232 10.3905L10.3239 6.19526C10.5443 5.93491 10.9016 5.93491 11.122 6.19526C11.3424 6.45561 11.3424 6.87772 11.122 7.13807L7.17139 11.8047C6.95099 12.0651 6.59364 12.0651 6.37324 11.8047L2.42263 7.13807C2.20222 6.87772 2.20222 6.45561 2.42263 6.19526Z"
          />
        </svg>
      </button>
      @if (isDropdownOpen) {
      <app-dropdown
        [options]="dropdownMenuOptions"
        (handleSelection)="handleSelected($event)"
        data-test-id="app-topnav-dropdown"
      ></app-dropdown>
      }
    </div>
    }
  </div>
</nav>
